module.exports = __webpack_public_path__ + "img/couples_13_V.3724c9d4.webp";